import React from "react";

import { Text } from "../../core/design-system/Text";
import { Img } from "../../core/design-system/Img";
import { useTheme } from "../../../theme/ThemeProvider";

interface ServicesProps {
  type?: string;
}

const Services: React.FC<ServicesProps> = (props) => {
  const { theme } = useTheme();

  const data1 = [
    { userImage: `${theme}-send-money.svg`, sendMoneyText: "Send Money" },
    { userImage: `${theme}-invest-money.svg`, sendMoneyText: "Invest Money" },
    {
      userImage: `${theme}-loan.svg`,
      sendMoneyText: "Beneficiaries",
    },
    { userImage: `${theme}-payments.svg`, sendMoneyText: "Bill Payments" },
  ];

  const data2 = [
    { userImage: `${theme}-current-month.svg`, sendMoneyText: "Current Month" },
    { userImage: `${theme}-last-month.svg`, sendMoneyText: "Last Month" },
    {
      userImage: `${theme}-last-three-months.svg`,
      sendMoneyText: "Last 3 Months",
    },
    { userImage: `${theme}-statements.svg`, sendMoneyText: "Statements" },
  ];

  return (
    <div
      className="flex flex-col items-center gap-[1em] rounded-xl 
    border border-solid border-blue_gray-50_02 bg-gray-100_01 pt-[1em] "
    >
      <div className="flex w-[94%] flex-wrap items-start justify-between gap-5 md:w-full md:px-5">
        <Text
          as="p"
          className="xs:text-xs sm:text-xs md:text-xs lg:text-sm xl:text-xs 2xl:text-[1.188rem]  5xl:font-normal"
        >
          {props.type}
        </Text>

        <Text
          as="p"
          className="!text-primaryText xs:text-xs sm:text-xs md:text-xs lg:text-sm xl:text-xs 2xl:text-sm 3xl:text-sm 4xl:text-lg 5xl:text-lg hover:cursor-pointer"
        >
          View all
        </Text>
      </div>
      <div className="flex xs:gap-[0.8rem] sm:gap-[0.8rem] xl:gap-5  w-full px-5 overflow-x-scroll no-scrollbar">
        {(props.type === "Services" ? data1 : data2).map((d, index) => (
          <div
            key={"servicesList" + index}
            className="flex flex-col xl:w-3/12 xs:p-4 lg:w-4/12 items-center xs:gap-3 sm:gap-3 xl:gap-4 5xl:min-h-40 rounded-[1rem] border border-solid border-blue_gray-50_02 bg-white-A700 xs:px-2 sm:px-2 sm:flex-1  md:px-4 2xl:py-[1rem] justify-center sm:w-full xs:flex-1"
          >
            <Img
              src={d.userImage}
              alt="user image"
              className=" xs:size-[2.75rem] 5xl:size-[4rem] rounded-[0.5em]"
            />
            <Text
              as="p"
              className="!text-black-900 xs:text-[0.6em] sm:text-[0.6em] md:text-xs lg:text-sm xl:text-xs 2xl:text-sm 3xl:text-sm 4xl:text-lg 4xl:font-normal"
            >
              {d.sendMoneyText}
            </Text>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between gap-5 self-stretch rounded-bl-xl rounded-br-xl border border-solid border-blue_gray-50_02 bg-white-A700 py-3.5 xs:pl-[1em]  pl-[4em] pr-[1.2em] sm:pl-[1em]">
        <div className="flex justify-center items-center gap-2">
          <Img
            src={
              props.type !== "Services" ? "zap.svg" : "img_credit_card_02.svg"
            }
            alt="credit card image"
            className="h-[1.2em] w-[1.2em] xs:size-4 "
          />
          <Text
            as="p"
            className="!text-black-900 xs:text-xs sm:text-xs md:text-xs lg:text-sm xl:text-xs 2xl:text-xs 3xl:text-sm 4xl:text-sm 5xl:text-sm 5xl:font-normal"
          >
            {props.type === "Services"
              ? " Setup autopay to avoid late fee on bills"
              : "Get instant cash against your deposits"}
          </Text>
        </div>
        <Img
          src="img_arrow_right.svg"
          alt="arrow right image"
          className="h-[1.2em] w-[1.2em] stroke-current"
          color="black-900"
        />
      </div>
    </div>
  );
};

export default Services;
